import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as pullRequestRequirementLinks from '../../pull-request-requirement-links'

export const RESOURCE = {
  payload: {
    description:
      'One link between a pull request and a Jira task it covers, keyed <pr>_<jira key>.',
    dimension: pullRequestRequirementLinks.RESOURCE.payload,
    level: 0,
    name: 'Pull Request Requirement Link',
    partialId: PartialId.Standard.create('pr_req_link'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
